export default {
  Confirm: 'Confirmez',
  Cancel: 'Annuler',
  'The minimum time length is xxxs!': 'La durée minimale est de {{num}}s!',
  'The maximum time length is 50s!': 'La durée maximale est de 50s!',
  'Online service, no download required': 'Service en ligne, aucun téléchargement requis',
  'Add up to 20MB file': "Ajoutez un fichier jusqu'à 20 Mo",
  'Support common formats': 'Prise en charge des formats courants',
  'Best for general editing requirements': "Idéal pour les exigences d'édition générales",
  '0 second wait': "0 seconde d'attente",
  'No size limits': 'Aucune limite de taille',
  'Support 1000+ formats': 'Supporte plus de 1000 formats',
  'Stable processing': 'Traitement stable',
  'Get access to': 'Accédez au',
  'Get access to HitPaw Toolkit!': 'Accédez au Toolkit de HitPaw !',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    "Supporte le découpage, le recadrage et la rotation, l'ajustement, la vitesse, l'ajout de musique, les arrêts de mouvement, etc.",
  'The easiest video editing software for beginners':
    'Le logiciel de montage vidéo le plus simple pour les débutants',
  'Remove watermark from videos and images in simple clicks':
    'Supprimez le filigrane des vidéos et des images en quelques clics.',
  'TRY IT FREE': 'ESSAYEZ-LE GRATUITEMENT',
  'BUY NOW': 'ACHETEZ MAINTENANT',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Une analyse réussie ! Votre fichier est supérieur à 100 Mo et ne peut pas être édité par HitPaw Online,veuillez',
  'download the video': ' télécharger la vidéo',
  'and then use HitPaw Toolkit to proceed.':
    ' et utiliser ensuite la boîte à outils HitPaw pour continuer.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Ajoutez au maximum 10 clips vidéo. Obtenez HitPaw Toolkit pour plus de fonctionnalités.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'La taille du fichier ne peut pas être supérieure à 20MB. Obtenez HitPaw Toolkit pour plus de fonctionnalités.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'La durée minimale est de 1s! Obtenez HitPaw Toolkit pour plus de fonctionnalités.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Ajoutez au maximum 3 vidéos. Obtenez HitPaw Toolkit pour plus de fonctionnalités.',
  'This format is not supported currently.': "Ce format n'est pas pris en charge actuellement.",
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    "Ce format n'est pas pris en charge actuellement. Obtenez HitPaw Toolkit pour plus de fonctionnalités.",
  'Processing failed. Get HitPaw Toolkit for stable processing.':
    'Échec de la génération de la vidéo !',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Échec du chargement!',
  'Are you sure you want to delete it?': 'Êtes-vous sur de vouloir le supprimer ?',
  'Failed to extract the audio!': "Échec de l'extraction de l'audio!",
  'Coming Soon': 'Prochainement',
  'Learn more': 'En savoir plus',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    "Ajoutez jusqu'à 2 fichiers. Obtenez HitPaw Toolkit pour plus de fonctionnalités.",
  Download: 'Télécharger',
  'Try Again': 'Veuillez réessayer',
  Failed: 'Echec',
  'Get Started': 'Commencer',
  Start: 'Démarrer',
  End: 'Finir',
  Export: 'Exportater',
  'Your audio is ready!': 'Votre audio est prêt!',
  'Download Audio': 'Télécharger Audio',
  YES: 'OUI',
  'Export Failed': "Échec de l'exportation",
  'Error occurs, the file cannot be added':
    "Une erreur s'est produit, le fichier ne peut pas être ajouté.",
  'Support merging audio files at most': 'Supporte la fusion de {{num}} fichiers audio au maximum',
  'Are you sure you want to delete this task?': 'Êtes-vous sûr de vouloir supprimer cette tâche?',
  Processing: 'Traitement',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    "N'oubliez pas de télécharger votre fichier, il sera abondant 24h plus tard.",
  Uploading: 'Chargement en cours',
  'Go Edit': 'Éditer',
  'Generate Files Successfully!': 'Le fichier est généré avec succès!',
  'Your order is being paid...': 'Votre commande est en cours de paiement',
  'Not yet': 'Not Yet',
  'Payment completed': 'Yes',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
